module.exports = __webpack_public_path__ + "static/media/logo.9fb6c2dc.svg";